export const stripBase64DataUrlPrefix = (value) => {
    if (!value) return '';

    const str = String(value);
    const marker = 'base64,';
    const idx = str.indexOf(marker);

    // Se já for base64 “puro”, mantém como está
    if (idx === -1) return str;

    return str.slice(idx + marker.length);
};

export const urlToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();

    const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });

    return stripBase64DataUrlPrefix(dataUrl);
};

